import moment from 'moment';

export default {
  model: 'LFFSpheromak',
  datetime: moment.utc().format('YYYY-MM-DDTHH:mm:ss'),
  latitude: 0,
  longitude: 0,
  radius: 10,
  speed: 650,
  tilt: 0,
  flux: 1e13,
  chirality: 1,
  density: 1e-18,
  temperature: 8e5,
};
